export default __webpack_public_path__ + "static/logo-horizontal-b63c008e68d5d9e2602943a30085e64b.svg";